import { Component, DestroyRef, effect, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoadingSpinnerComponent } from './shared/loading/loading-spinner/loading-spinner.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AvatarService } from './store/avatar.service';
import { AuthService } from './auth/auth.service';
import { HttpClient } from '@angular/common/http';
import { provideNgIconLoader, withCaching } from '@ng-icons/core';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [ RouterOutlet, LoadingSpinnerComponent ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: [
    provideNgIconLoader((name) => {
      const http = inject(HttpClient);
      return http.get(`/assets/icons/${name}.svg`, { responseType: 'text' });
    }, withCaching()),
  ],
})
export class AppComponent {
  private destr = inject(DestroyRef);
  user = inject(AuthService).user;
  avatar = inject(AvatarService);

  constructor() {
    effect(() => {
      const userId = this.user().id;
      if (!userId) return;
      this.avatar.getAvatar(userId).pipe(takeUntilDestroyed(this.destr)).subscribe();
    });
  }
}
